// extracted by mini-css-extract-plugin
export default {"card":"Card_card__7Eml9","title":"Card_title__qr0vL","price":"Card_price__QgdqT","image":"Card_image__LwFVE","showmore":"Card_showmore__Q5A61"};